import React, { useState } from "react";
const ApprovalOverlayListView = ({listview,addElipsis, invoices, formatNumber, dividerNumber, vendorPaymentData, dbtData, dbtPaymentData, childAllocationData}) => {
    const [tableAccordian, setTableAccordian] = useState(false);
    const [paymentAccordian, setpaymentAccordion] = useState(false);
    const [dbtNachApproval, setDbtNachApproval] = useState(false);
    const [dbtNachPayment, setDbtNachPayment] = useState(false);
    const [childAllo, setChildAllo] = useState(false);
    const [tableChildAccordian, setTableChildAccordian] = useState({});


    return (
        <>
        {!listview === false ? null : (
            <>
              {/* ======================= vendor table==================== */}
              <div className="w-100 overflow-x-auto">
                <div>
                  {/* =======================heading========================= */}
                  <div className="d-flex justify-content-between text-center border">
                    <div className="fw-bold ps-2">Vendor</div>
                  </div>

                  {/* ===========================datas========================= */}

                  <div
                    className="d-flex border text-center flex-column position-relative overflow-hidden"
                    style={tableAccordian ? null : { height: "34px" }}
                  >
                    <div className="d-flex ">
                      <div className=" p-1">
                        {!tableAccordian ? (
                          <i
                            className="icon-arrow_right cursor-pointer"
                            onClick={() => setTableAccordian(true)}
                          ></i>
                        ) : (
                          <i
                            className="icon-arrow_drop_down cursor-pointer"
                            onClick={() => setTableAccordian(false)}
                          ></i>
                        )}
                        Pending for approval
                      </div>
                    </div>

                    {/* ====================child datas================================== */}
                    <div
                      className=""
                      style={{
                        background: "silver",
                        height: paymentAccordian ? null : "auto",
                      }}
                    >
                      <div className="d-flex justify-content-between text-center">
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Sr.No.
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          vendor
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Invoice No/Date
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Sanction Order/Date
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Sanction Amount
                        </div>
                      </div>

                      {
                        invoices?.map((val, ind)=>(
                          <div className="d-flex">
                        <div className="border p-1" style={{ width: "25%" }}>
                          {ind + 1}
                        </div>
                        <div className="border p-1" style={{ width: "25%" }}>
                        {addElipsis(val?.company_name, 12)}
                        </div>
                        <div className="border p-1" style={{ width: "25%" }}>
                        {addElipsis(
                                      val?.invoice_no +
                                        " | " +
                                        val?.invoice_date,
                                      18
                                    )}
                        </div>
                        <div className="border p-1" style={{ width: "25%" }}>
                        {val?.sanction_order_value} |{" "}
                        {val?.sanction_order_date}
                        </div>
                        <div className="border p-1" style={{ width: "25%" }}>
                        {formatNumber(
                                      val?.sanction_amount,
                                      "indian"
                                    )}
                        </div>
                      </div>
                        ))
                      }
                     

                    </div>
                  </div>
                  <div
                    className="d-flex border text-center flex-column position-relative overflow-hidden"
                    style={paymentAccordian ? null : { height: "34px" }}
                  >
                    <div className="d-flex ">
                      <div className=" p-1">
                        {!paymentAccordian ? (
                          <i
                            className="icon-arrow_right cursor-pointer"
                            onClick={() => setpaymentAccordion(true)}
                          ></i>
                        ) : (
                          <i
                            className="icon-arrow_drop_down cursor-pointer"
                            onClick={() => setpaymentAccordion(false)}
                          ></i>
                        )}
                        Pending for Payment
                      </div>
                    </div>

                    {/* ====================child datas================================== */}
                    <div
                      className=""
                      style={{
                        background: "silver",
                        height: tableChildAccordian ? null : "auto",
                      }}
                    >
                      <div className="d-flex justify-content-between text-center">
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Sr.No.
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          vendor
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Invoice No/Date
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Sanction Order/Date
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Sanction Amount
                        </div>
                      </div>

                      {
                        vendorPaymentData?.map((val, ind)=>(
                          <div className="d-flex">
                        <div className="border p-1" style={{ width: "25%" }}>
                          {ind + 1}
                        </div>
                        <div className="border p-1" style={{ width: "25%" }}>
                        {addElipsis(val?.company_name, 12)}
                        </div>
                        <div className="border p-1" style={{ width: "25%" }}>
                        {addElipsis(
                                      val?.invoice_no +
                                        " | " +
                                        val?.invoice_date,
                                      18
                                    )}
                        </div>
                        <div className="border p-1" style={{ width: "25%" }}>
                        {val?.sanction_order_value} |{" "}
                        {val?.sanction_order_date}
                        </div>
                        <div className="border p-1" style={{ width: "25%" }}>
                        {formatNumber(
                                      val?.payable_amount,
                                      "indian"
                                    )}
                        </div>
                      </div>
                        ))
                      }
                     


                    </div>
                  </div>
                </div>
              </div>

              {/* =========================DBT/Nach table =============================== */}

              <div className="w-100 overflow-x-auto">
                <div>
                  {/* =======================heading========================= */}
                  <div className="d-flex justify-content-between text-center border">
                    <div className="fw-bold ps-2">DBT/Nach</div>
                  </div>

                  {/* ===========================datas========================= */}

                  <div
                    className="d-flex border text-center flex-column position-relative overflow-hidden"
                    style={dbtNachApproval ? null : { height: "34px" }}
                  >
                    <div className="d-flex ">
                      <div className=" p-1">
                        {!dbtNachApproval ? (
                          <i
                            className="icon-arrow_right cursor-pointer"
                            onClick={() => setDbtNachApproval(true)}
                          ></i>
                        ) : (
                          <i
                            className="icon-arrow_drop_down cursor-pointer"
                            onClick={() => setDbtNachApproval(false)}
                          ></i>
                        )}
                        Pending for approval
                      </div>
                    </div>

                    {/* ====================child datas================================== */}
                    <div
                      className=""
                      style={{
                        background: "silver",
                        height: paymentAccordian ? null : "auto",
                      }}
                    >
                      <div className="d-flex justify-content-between text-center">
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Sr.No.
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Department Level/Name
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Scheme/Subhead Code
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Order No./Date
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Sanction Amount
                        </div>
                      </div>
                      {
                        dbtData?.map((val, ind)=>(
                          <div className="d-flex">
                        <div className="border p-1" style={{ width: "25%" }}>
                          {ind + 1}
                        </div>
                        <div className="border p-1" style={{ width: "25%" }}>
                        {addElipsis(
                                        val?.department_level +
                                          " | " +
                                          val?.department_name,
                                        13
                                      )}
                        </div>
                        <div className="border p-1" style={{ width: "25%" }}>
                        {val?.code} | {val?.subhead_code}
                        </div>
                        <div className="border p-1" style={{ width: "25%" }}>
                        {addElipsis(
                                      val?.reimbursement_order_no +
                                        " | " +
                                        val?.reimbursement_order_date,
                                      13
                                    )}
                        </div>
                        <div className="border p-1" style={{ width: "25%" }}>
                        {val?.reimbursement_order_value == 0
                                      ? "-"
                                      : formatNumber(
                                          val?.reimbursement_order_value,
                                          "indian"
                                        )}
                        </div>
                      </div>
                        ))
                      }
                    

                    </div>
                  </div>
                  <div
                    className="d-flex border text-center flex-column position-relative overflow-hidden"
                    style={dbtNachPayment ? null : { height: "34px" }}
                  >
                    <div className="d-flex ">
                      <div className=" p-1">
                        {!dbtNachPayment ? (
                          <i
                            className="icon-arrow_right cursor-pointer"
                            onClick={() => setDbtNachPayment(true)}
                          ></i>
                        ) : (
                          <i
                            className="icon-arrow_drop_down cursor-pointer"
                            onClick={() => setDbtNachPayment(false)}
                          ></i>
                        )}
                        Pending for Payment ==
                      </div>
                    </div>

                    {/* ====================child datas================================== */}
                    <div
                      className=""
                      style={{
                        background: "silver",
                        height: tableChildAccordian ? null : "84px",
                      }}
                    >
                      <div className="d-flex justify-content-between text-center">
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Sr.No.
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Department Level/Name
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Scheme/Subhead Code
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Order No./Date
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Sanction Amount
                        </div>
                      </div>
                      {
                        dbtPaymentData?.map((val, ind)=>(
                          <div className="d-flex">
                        <div className="border p-1" style={{ width: "25%" }}>
                          {ind + 1}
                        </div>
                        <div className="border p-1" style={{ width: "25%" }}>
                        {addElipsis(
                                        val?.department_level +
                                          " | " +
                                          val?.department_name,
                                        13
                                      )}
                        </div>
                        <div className="border p-1" style={{ width: "25%" }}>
                        {val?.code} | {val?.subhead_code}
                        </div>
                        <div className="border p-1" style={{ width: "25%" }}>
                        {addElipsis(
                                      val?.reimbursement_order_no +
                                        " | " +
                                        val?.reimbursement_order_date,
                                      13
                                    )}
                        </div>
                        <div className="border p-1" style={{ width: "25%" }}>
                        {val?.reimbursement_order_value == 0
                                      ? "-"
                                      : formatNumber(
                                          val?.reimbursement_order_value,
                                          "indian"
                                        )}
                        </div>
                      </div>
                        ))
                      }
                    </div>
                  </div>
                </div>
              </div>

              {/* =========================salary table ================================= */}

              <div className="w-100 overflow-x-auto">
                <div>
                  {/* =======================heading========================= */}
                  <div className="d-flex justify-content-between text-center border">
                    <div className="fw-bold ps-2">Salary</div>
                  </div>

                  {/* ===========================datas========================= */}

                  <div
                    className="d-flex border text-center flex-column position-relative overflow-hidden"
                    style={tableAccordian ? null : { height: "34px" }}
                  >
                    <div className="d-flex ">
                      <div className=" p-1">
                        {!tableAccordian ? (
                          <i
                            className="icon-arrow_right cursor-pointer"
                            onClick={() => setTableAccordian(true)}
                          ></i>
                        ) : (
                          <i
                            className="icon-arrow_drop_down cursor-pointer"
                            onClick={() => setTableAccordian(false)}
                          ></i>
                        )}
                        Pending for approval
                      </div>
                    </div>

                    {/* ====================child datas================================== */}
                    <div
                      className=""
                      style={{
                        background: "silver",
                        height: paymentAccordian ? null : "84px",
                      }}
                    >
                      <div className="d-flex justify-content-between text-center">
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Sr.No.
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          vendor
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Invoice No/Date
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Sanction Order/Date
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Sanction Amount
                        </div>
                      </div>

                      <div className="d-flex">
                        <div className="border p-1" style={{ width: "25%" }}>
                          {" "}
                          1
                        </div>
                        <div className="border p-1" style={{ width: "25%" }}>
                          {" "}
                          1353
                        </div>
                        <div className="border p-1" style={{ width: "25%" }}>
                          radhe radhe
                        </div>
                        <div className="border p-1" style={{ width: "25%" }}>
                          20000000000
                        </div>
                        <div className="border p-1" style={{ width: "25%" }}>
                          20000000000
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="d-flex border text-center flex-column position-relative overflow-hidden"
                    style={paymentAccordian ? null : { height: "34px" }}
                  >
                    <div className="d-flex ">
                      <div className=" p-1">
                        {!paymentAccordian ? (
                          <i
                            className="icon-arrow_right cursor-pointer"
                            onClick={() => setpaymentAccordion(true)}
                          ></i>
                        ) : (
                          <i
                            className="icon-arrow_drop_down cursor-pointer"
                            onClick={() => setpaymentAccordion(false)}
                          ></i>
                        )}
                        Pending for Payment
                      </div>
                    </div>

                    {/* ====================child datas================================== */}
                    <div
                      className=""
                      style={{
                        background: "silver",
                        height: tableChildAccordian ? null : "84px",
                      }}
                    >
                      <div className="d-flex justify-content-between text-center">
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Sr.No.
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Department Level/Name
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Scheme/Subhead Code
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Order No./Date
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "25%" }}
                        >
                          Sanction Amount
                        </div>
                      </div>

                      <div className="d-flex">
                        <div className="border p-1" style={{ width: "25%" }}>
                          {" "}
                          1
                        </div>
                        <div className="border p-1" style={{ width: "25%" }}>
                          {" "}
                          1353
                        </div>
                        <div className="border p-1" style={{ width: "25%" }}>
                          radhe radhe
                        </div>
                        <div className="border p-1" style={{ width: "25%" }}>
                          20000000000
                        </div>
                        <div className="border p-1" style={{ width: "25%" }}>
                          20000000000
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* =========================Budget Allocation table ======================= */}

              <div className="w-100 overflow-x-auto">
                <div>
                  {/* =======================heading========================= */}
                  <div className="d-flex justify-content-between text-center border">
                    <div className="fw-bold ps-2">Budget Allocation</div>
                  </div>

                  {/* ===========================datas========================= */}

                  <div
                    className="d-flex border text-center flex-column position-relative overflow-hidden"
                    style={childAllo ? null : { height: "34px" }}
                  >
                    <div className="d-flex ">
                      <div className=" p-1">
                        {!childAllo ? (
                          <i
                            className="icon-arrow_right cursor-pointer"
                            onClick={() => setChildAllo(true)}
                          ></i>
                        ) : (
                          <i
                            className="icon-arrow_drop_down cursor-pointer"
                            onClick={() => setChildAllo(false)}
                          ></i>
                        )}
                        Pending for approval
                      </div>
                    </div>

                    {/* ====================child datas================================== */}
                    <div className={`${childAllo ? "overflow-x-auto" : null}`}>
                      <div
                        className=""
                        style={{
                          background: "silver",
                          width: "1400px",
                          height: paymentAccordian ? null : "auto",
                        }}
                      >
                        <div className="d-flex justify-content-between text-center">
                          <div
                            className="fw-bold border px-1"
                            style={{ width: "25%" }}
                          >
                            Sr.No.
                          </div>
                          <div
                            className="fw-bold border px-1"
                            style={{ width: "25%" }}
                          >
                            Scheme Name
                          </div>
                          <div
                            className="fw-bold border px-1"
                            style={{ width: "25%" }}
                          >
                            Order No./Date
                          </div>
                          <div
                            className="fw-bold border px-1"
                            style={{ width: "25%" }}
                          >
                            Child Count
                          </div>
                          <div
                            className="fw-bold border px-1"
                            style={{ width: "25%" }}
                          >
                            Provision Allocation
                          </div>
                          <div
                            className="fw-bold border px-1"
                            style={{ width: "25%" }}
                          >
                            Released Allocation
                          </div>
                        </div>
                        {
                          childAllocationData?.map((val, ind)=>(
                            <div className="d-flex">
                          <div className="border p-1" style={{ width: "25%" }}>
                            {ind + 1}
                          </div>
                          <div className="border p-1" style={{ width: "25%" }}>
                          {addElipsis(val?.name, 13)}
                          </div>
                          <div className="border p-1" style={{ width: "25%" }}>
                          {addElipsis(
                                      val?.budget_order_no +
                                        " " +
                                        val?.budget_order_date,
                                      13
                                    )}
                          </div>
                          <div className="border p-1" style={{ width: "25%" }}>
                          {val?.total_departments}
                          </div>
                          <div className="border p-1" style={{ width: "25%" }}>
                          {val?.total_scheme_provisional_allocation ==
                                    0
                                      ? "-"
                                      : formatNumber(
                                          val?.total_scheme_provisional_allocation,
                                          "indian"
                                        )}
                          </div>
                          <div className="border p-1" style={{ width: "25%" }}>
                          {val?.total_scheme_released_allocation == 0
                                      ? "-"
                                      : formatNumber(
                                          val?.total_scheme_released_allocation,
                                          "indian"
                                        )}
                          </div>
                        </div>
                          ))
                        }
                       
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          </>
    )
}

export default ApprovalOverlayListView;